import classNames from "classnames"
import { FC } from "react"
import { Outlet, useMatch, useParams } from "react-router"

import { AccountType, KybPages, PageType } from "@app/config/pageTypes"
import { APP_MODE } from "@shared/config/appMode/appMode"
import { useAppModeStore } from '@shared/config/appMode.store'
import { useComponentVisibilityStore } from "@shared/store/useComponentVisibilityStore"
import GlobalAlertLayout from "@widgets/global_alert/GlobalAlertLayout"

import styles from "./twoColumnLayout.module.css"
import { ITwoColumnLayoutProps } from "./twoColumnLayout.type"
import Footer from '../footer/Footer'
import Grid from "../grid/Grid"
import GridItem from "../grid/GridItem"
import Logo from "../logo/Logo"
import NeuroNextLogo from '../logo/neuro_next/LogoNeuroNext'


const TwoColumnLayout: FC<ITwoColumnLayoutProps> = ({
    rightComponent,
    pageType,
}) => {
    const { accountType = '' } = useParams()
    const match = useMatch('/sign-up/:accountType/:step')
    const step = match?.params.step
    const isKybPages = step === KybPages.CheckKyb || step === KybPages.VerificationPending
    const isDarkTheme = accountType === AccountType.Business || isKybPages
    const { isSliderVisibleOnMobile } = useComponentVisibilityStore()

    const appMode = useAppModeStore(s => s.mode)
    const isWithoutCrypto = useAppModeStore(s => s.isWithoutCrypto)
    const isUk = appMode === APP_MODE.DEFAULT && isWithoutCrypto
    const logoUrl = isUk
        ? import.meta.env.VITE_BANXE_UK_PATH
        : import.meta.env.VITE_BANXE_COM_PATH

    const layoutClassNames = classNames(
        {
            [styles.darkTheme]: isDarkTheme,
        },
        styles.layout
    )
    const rightSideClassNames = classNames(
        styles.right,
        {
            [styles.hiddenMobileSlider]: pageType !== PageType.Registration || !isSliderVisibleOnMobile  || isKybPages,
        }
    )
    const gridContainerClassNames = classNames(styles.gridContainer)
    const logoClassnames = isSliderVisibleOnMobile
        && pageType === PageType.Registration
        ? styles.sliderLogo
        : styles.logo

    const contentColSize = appMode === APP_MODE.DEFAULT ? 4 : 8
    
    return (
        <div className={layoutClassNames}>
            <Grid className={gridContainerClassNames}>
                <GridItem sm={contentColSize} className={styles.left}>
                    { appMode === APP_MODE.NEURONEXT ?
                        <NeuroNextLogo isDarkTheme={ isDarkTheme } />
                        :
                        <Logo
                            href={ logoUrl }
                            className={logoClassnames}
                            data-inverted-color={ isDarkTheme }
                        />
                    }
                    {pageType !== PageType.Registration && 
                        <GlobalAlertLayout />
                    }
                    <Outlet />
                </GridItem>
                { appMode === APP_MODE.DEFAULT &&
                <GridItem sm={4} className={rightSideClassNames}>
                    {rightComponent}
                </GridItem>
                }
            </Grid>
            <Footer isUk={ isUk } />
        </div>
    )
}

export default TwoColumnLayout
